import { featureFlags, pages } from '@dvag/dfs-constant-config';
import { navigate } from '@dvag/dfs-orchestrator-client/messengers';
import featureFlag from './featureFlag';

export const navigateToDocumentAppointmentOrKundenreportExport = (
  householdId: string,
  personIdList?: string[],
): void => {
  const isKundenreportExportEnabled = featureFlag.gb?.isOn(featureFlags.enableKundenreportExport);

  if (isKundenreportExportEnabled) {
    navigate(pages.KUNDENREPORT_EXPORT.getUrl(householdId, true, personIdList), undefined, true);
    return;
  }

  navigate(pages.APPOINTMENT_DOCUMENTATION.getUrl(householdId, true));
};
